import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomDateAdapter } from './custom-date-adapter';
import {CUSTOM_DATE_FORMATS} from "./models/constants";

/**
 * Provides all necessary date and datetime adapters and formats for the application.
 * This single function can be used in your app.config.ts to set up date handling app-wide.
 */
export function provideCustomDateAdapters(): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: DateAdapter,
            useClass: CustomDateAdapter,
            deps: [MAT_DATE_LOCALE],
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: CUSTOM_DATE_FORMATS,
        },
    ]);
}